import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { ResumeDatabaseBanner } from 'components/Banners/ResumeDatabaseBanner';
import { SalarySurveyBanner } from 'components/Banners/SalarySurveyBanner';
import Box from 'components/Box';
import ClientOnly from 'containers/ClientOnly';
import { State as MainState } from 'store/main';
import { setHadResumeDatabaseAd } from 'store/main/ducks/layout';
import { promoteResumeDatabase } from 'utils/resumeDatabase';
import { promoteSalarySurvey } from 'utils/salarySurvey';

export function BannerAds() {
  const { currentUser, hadResumeDatabaseAd, hideSalarySurveyAd } = useSelector(
    (state: MainState) => ({
      hadResumeDatabaseAd: state.layout.hadResumeDatabaseAd,
      hideSalarySurveyAd: state.layout.hideSalarySurveyAd,
      currentUser: state.currentUser,
    })
  );
  const dispatch = useDispatch();
  const history = useHistory();

  const hasResumeDatabaseBanner = promoteResumeDatabase({
    currentUser,
    allowLoggedOut: true,
  });

  useEffect(() => {
    if (
      currentUser.isLoaded &&
      !hadResumeDatabaseAd &&
      hasResumeDatabaseBanner
    ) {
      dispatch(setHadResumeDatabaseAd(true));
    }
  }, [
    currentUser.isLoaded,
    dispatch,
    hadResumeDatabaseAd,
    hasResumeDatabaseBanner,
  ]);

  const hasSalarySurveyBanner =
    !hasResumeDatabaseBanner &&
    !hadResumeDatabaseAd &&
    !hideSalarySurveyAd &&
    !history.location.pathname.includes('/survey') &&
    promoteSalarySurvey({
      currentUser,
      allowDismissal: true,
    });

  return (
    <Box
      data-qa-id="ads-container"
      mt={[60, null, null, 0]}
      mb={[-60, null, null, 0]}
    >
      <ClientOnly>
        {hasResumeDatabaseBanner && (
          <ResumeDatabaseBanner currentUser={currentUser} />
        )}
        {hasSalarySurveyBanner && <SalarySurveyBanner />}
      </ClientOnly>
    </Box>
  );
}
